import Vue from 'vue'
import store from './store'
import moment from "moment";

moment.locale(localStorage.getItem("lang"))
moment.tz.setDefault("GMT");
Vue.directive('date-format', {
    bind: function (el, obj) {
        el.innerHTML = (obj.value == 'private') ? obj.value : moment.tz(moment(obj.value), store.state.config.generalSettings.timezone).format(store.state.config.generalSettings.date_format);
    },
    update: function (el, obj) {
        el.innerHTML = (obj.value == 'private') ? obj.value : moment.tz(moment(obj.value), store.state.config.generalSettings.timezone).format(store.state.config.generalSettings.date_format);
    }
})

Vue.directive('date-time-format', {
    bind: function (el, obj) {
        el.innerHTML = moment.tz(moment(obj.value), store.state.config.generalSettings.timezone).format(store.state.config.generalSettings.date_format + ' ' + store.state.config.generalSettings.time_format);
    },
    update: function (el, obj) {
        el.innerHTML = moment.tz(moment(obj.value), store.state.config.generalSettings.timezone).format(store.state.config.generalSettings.date_format + ' ' + store.state.config.generalSettings.time_format);
    }
})

Vue.directive('clock', {
    bind: function (el) {
        setInterval(() => {
            el.innerHTML = moment.tz(moment(), store.state.config.generalSettings.timezone).format(store.state.config.generalSettings.date_format + ' ' + store.state.config.generalSettings.time_format);
        }, 1000);
    }
})

Vue.directive('ucfirst', {
    bind: function (el, obj) {
        if (obj.value) {
            el.innerHTML = obj.value.charAt(0).toUpperCase() + obj.value.slice(1);
        }
    },
    update: function (el, obj) {
        if (obj.value) {
            el.innerHTML = obj.value.charAt(0).toUpperCase() + obj.value.slice(1);
        }
    }
})

function formatMoney(n, c, d, t) {
    var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

Vue.directive('cformat', {
    bind: function (el, obj) {
        if (obj.value) {
            el.innerHTML = formatMoney(obj.value, 2, '.', '\'');
        } else {
            el.innerHTML = '0.00';
        }
    },
    update: function (el, obj) {
        if (obj.value) {
            el.innerHTML = formatMoney(obj.value, 2, '.', '\'');
        } else {
            el.innerHTML = '0.00';
        }
    }
})

Vue.filter('currency-format', function (value) {
    if (isNaN(value)) {
        return '0.00';
    }
    return store.state.config.generalSettings.currency_code + " " + formatMoney(value, 2, '.', '\'')
});
Vue.filter("nl2br", str => str ? str.replace(/(?:\r\n|\r|\n)/g, '<br>') : '')

Vue.filter("convertWordToPastTense", function(word) {
    if (word.substring(word.length - 1, word.length) === 'e') {
        return word + 'd';
    } else {
        return word + 'ed';
    }
});




// WEBPACK FOOTER //
// ./src/services/directive.js